<template>
    <form
        id="tester-eligibilite"
        name="tester-eligibilite"
        method="post"
        :action="initEligibilityUrl"
    >
        <input type="hidden" name="token" :value="token">
        <input type="hidden" name="offreInternet" :value="highlightedInternetOfferSeoId">
        <input type="hidden" name="offreMobile" :value="highlightedMobileOfferSeoId">
    </form>
</template>

<script>
export default {
    name: "EligibilityForm",
    props: {
        token: {type: String, required: true},
        initEligibilityUrl: {type: String, required: true},
        internetOffersModel: {type: Array, required: true},
        mobileOffersModel: {type: Array, required: true}
    },
    computed: {
        highlightedInternetOfferSeoId() {
            return this.internetOffersModel.find(model => model.highlighted === true).seoId
        },
        highlightedMobileOfferSeoId() {
            return this.mobileOffersModel.find(model => model.highlighted === true).seoId
        }
    },
}
</script>

<style scoped>

</style>
